import { useMemo } from "react";
import { useDropzone } from "react-dropzone";

import { baseStyle, activeStyle, acceptStyle, rejectStyle, thumb, thumbInner, Img, thumbsContainer } from "./uploadFile.style";
import { isString } from "lodash";

export const ImageUpload = ({
	data,
	setData,
	files,
	setFiles,
	returnFile = false,
	format = "*",
	text = "Arrastre y suelte algunos archivos aquí, o haga clic para seleccionar archivos",
}) => {
	const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
		multiple: false,
		accept: format === "*" ? `image/${format}` : { "image/png": [] },
		onDrop: (acceptedFiles) => {
			setData({
				...data,
				url_media: acceptedFiles.map((file) => {
					return Object.assign(file, {
						preview: URL.createObjectURL(file),
					});
				})[0],
				...(returnFile ? { signature_url: null } : {}),
			});
			setFiles(
				acceptedFiles.map((file) => {
					return Object.assign(file, {
						preview: URL.createObjectURL(file),
					});
				}),
			);
		},
	});

	const style = useMemo(
		() => ({
			...baseStyle,
			...(isDragActive ? activeStyle : {}),
			...(isDragAccept ? acceptStyle : {}),
			...(isDragReject ? rejectStyle : {}),
		}),
		[isDragActive, isDragReject, isDragAccept],
	);

	const thumbs = files.map((file, i) => {
		let newFile = file;
		if (isString(file)) {
			newFile = {};

			newFile.name = file.split("/").pop();
			newFile.preview = file;
		}

		return (
			<div style={returnFile ? { ...thumb, width: "100%" } : thumb} key={i}>
				<div style={thumbInner}>
					<img alt={newFile.name} src={newFile.preview} style={Img} onClick={() => console.info(i)} />
				</div>
			</div>
		);
	});

	return (
		<div>
			<div
				{...getRootProps({
					style,
					className: "dropzone",
				})}
			>
				<input {...getInputProps()} />
				<p style={{ marginBottom: "0rem" }}>{text}</p>
			</div>
			<aside style={thumbsContainer}>{thumbs}</aside>
		</div>
	);
};
